import { z } from "zod";

/**
 * #1292: what a dbt job's save answers beside the saved job when the save is fine and still worth
 * a second look. The sentence is the server's, as every cause sentence is: the client shows it and
 * never composes one.
 *
 * `SELECTS_NO_MODELS`: the selector is a valid one and picks no model of the project the Models
 * tab lists. It is a warning, not a refusal, because the project that tab lists is the last one
 * dbt read and the job may be written ahead of the model it will select.
 */
export const dbtJobWarningSchema = z.object({
  code: z.literal("SELECTS_NO_MODELS"),
  message: z.string(),
});
export type DbtJobWarning = z.infer<typeof dbtJobWarningSchema>;

const SELECTS_NO_MODELS_MESSAGE =
  "This selector picks no models in the project the Models tab lists. The dbt job is saved, and it builds nothing until a model matches.";

export function selectsNoModelsWarning(): DbtJobWarning {
  return { code: "SELECTS_NO_MODELS", message: SELECTS_NO_MODELS_MESSAGE };
}
